<div class="container-fluid">
    <div class="header-container flex">
        <div class="page-header">
            <span class="fa fa-cube"></span>{{ "bikeshop.menu.incoming_notifications" | translate }}
        </div>
    </div>

    <div class="content">
        <div class="row margin-top-8" style="display: flex;align-items: center;">
            <div class="col-md-4">
                <div class="label" *ngIf="linkedPartners && linkedPartners.length > 1">
                    {{ 'bikeshop.menu.incoming_notifications_fromstore' | translate }}
                </div>
                <div *ngIf="linkedPartners && linkedPartners.length > 1">
                    <p-multiSelect [options]="linkedPartners" [(ngModel)]="selectedPartners"
                                   placeholder="Select a store" optionLabel="partnerName"
                                   (onChange)="updateFilter($event.value)"></p-multiSelect>
                </div>
            </div>
            <div class="col-md-4 label">
            </div>
            <div class="col-md-4">
                <div class="p-inputgroup">
                    <input type="text" pInputText [(ngModel)]="search" placeholder="{{
              'bikeshop.all_notifications.search' | translate
            }}" (keyup.enter)="searchMessages()"/>
                    <span class="p-inputgroup-addon"><i class="fa hubtiger-search"
                                                        (click)="searchMessages()"></i></span>
                </div>
            </div>
        </div>
        <div class="loading" *ngIf="loading">
            <div class="loader"></div>
        </div>
        <!--<div class="row margin-top-16">
          <div pTooltip="Create a new cyclist" tooltipPosition="left" class="fa fa-user-plus font-button pull-right"
            style="margin-left: auto!important;margin-right: 16px!important;" (click)="addUser()"></div>
        </div>-->
        <div class="margin-top-16">
            <p-table #cyclistsTable [columns]="columns" [value]="notifications">
                <ng-template pTemplate="header" let-columns>
                    <tr>
                        <th *ngFor="let col of columns"
                            [ngStyle]="{'width' : col.field === 'MessageRead' ? '60px' : col.field === 'Message' ? '35%' : 'auto' }">
                            {{ col.header }}
                        </th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-notification let-columns="columns">
                    <tr [pSelectableRow]="notification">
                        <td *ngFor="let col of columns">
                            <div *ngIf="col.type === 'readStatus'"><span class="fa"
                                                                         (click)="markAsRead(notification.ID, notification.PartnerID)"
                                                                         [ngClass]="{'fa-envelope-open-o' : notification[col.field], 'fa-envelope-o': !notification[col.field]}"></span>
                            </div>
                            <div *ngIf="col.type == 'jobcardno'">
                                <div (click)="openJobCard(notification.JobCardID, notification)"><u>
                                    {{ notification[col.field] }}</u>
                                </div>
                            </div>
                            <div *ngIf="col.type === 'string' || col.type === 'date'"
                                 [ngClass]="{'unread-messages': !notification.MessageRead}">
                                {{
                                col.type === 'date' ? (notification[col.field] | date : countryData.AngularDateFormat + ' h:mm a')
                                    : notification[col.field]
                                }}
                            </div>
                            <div *ngIf="col.type === 'status'"
                                 [ngClass]="{'unread-messages': !notification.MessageRead}">
                                {{getStatusDescription(notification.JobCardStatusID)}}
                            </div>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
            <p-paginator #paginator [rows]="limit" [totalRecords]="totalRecords" (onPageChange)="paginate($event)">
            </p-paginator>
        </div>
        <div>
            <small>
                {{ "bikeshop.cyclist.note" | translate }}
            </small>
        </div>
    </div>
</div>
